import { render, staticRenderFns } from "./advertisementVertical.vue?vue&type=template&id=4f461572&scoped=true&"
import script from "./advertisementVertical.vue?vue&type=script&lang=js&"
export * from "./advertisementVertical.vue?vue&type=script&lang=js&"
import style0 from "./advertisementVertical.vue?vue&type=style&index=0&id=4f461572&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f461572",
  null
  
)

export default component.exports